export default "__VITE_ASSET__CuOxCvd3__"